<template>
  <div class="GridOperatorApproval">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import { ChargingStationVersion } from '@/config'
import FieldSet from '@/components/form/FieldSet'

import { minValue } from 'vuelidate/lib/validators'

export default {
  name: 'CPOAdditionalCosts',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: 'Werkzaamheden',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'CPOAdvice',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'SumAdditionalCost': {
          'type': 'number',
          'title': 'Totale kosten voor aanvullende werkzaamheden',
        },
        'ChargingStationVersion': {
            'type': 'string',
            'title': 'Uitvoering laadpaal',
            'enumNames': [...ChargingStationVersion],
            'enum': [...ChargingStationVersion],
        },
        'AdditionalCostDescription': {
            'type': 'string',
            'title': 'Toelichting op de uitvoering',
            'format': 'textarea',
            'description': 'Dit betreft werkzaamheden welke door de gemeente uit te voeren zijn.',
            'rows': 2,
        },
      },
      layout: [
      {
        'columns': '1fr',
        'fields': ['ChargingStationVersion']
      },
      {
        'columns': '1fr',
        'fields': ['AdditionalCostDescription'],
      }],
      validation: {
        'SumAdditionalCost': {
          minValue: minValue(0),
        },
      },
    }
  },
}
</script>
